import React, {useState} from 'react';
import Icon from './Icon';
import {Button} from "./Button";
import Modal from "./Modal";
import {TextAreaField} from "./FormField";


const Report = ({
        type = "",
        title = "",
        handleReport = () =>{}
    }) =>{

    const [message, setMessage] = useState("");
    const [toggle, setToggle] = useState(false);
    const [isError, setIsError] = useState(false);

    function handleSubmit() {
        if(message.length >= 1){
            handleReport(message);
            setMessage("");
            setIsError(false);
            setToggle(false);
        } else {
            setIsError(true);
        }
    }

    return (
        <div className="report">
            <div className="report-comment">
                {type === 'comment' ? (
                    <div onClick={() => setToggle(true)}><Icon type="report"/> Signaler</div>
                ) : type === 'button' ? (
                    <Button size={"small"}
                            btnStyle={"cancel-reverse"}
                            onClick={() => setToggle(true)}
                            content={"Signaler"}/>
                ) : type === 'button-answer' ? (
                    <Button size={"small"}
                            btnStyle={"cancel"}
                            onClick={() => setToggle(true)}
                            content={"Signaler"}/>
                ) : (
                    <div className="base-report"
                         onClick={() => setToggle(true)}>Signaler</div>
                )}
                <Modal toggle={toggle} handleClose={() => setToggle(false)}>
                    <div className="report-popup modal-container">
                        <div className={"modal-topline"}>Signaler {title ? ` : ${title}` : " un contenu sur Voissa"}</div>
                        <div className={"modal-body"}>
                            <p> Signalez ici un comportement ou contenu qui ne respecte pas la charte de notre
                                communauté</p>
                            <p className="red"><b>Donnez nous un maximum d’informations pour que nous puissions
                                agir:</b></p>
                            <TextAreaField placeholder={"Raison de votre signalement ..."}
                                           value={message}
                                           onChange={(event)=>setMessage(event.target.value)}/>
                        </div>
                        <div className={"modal-baseline"}>
                            {isError && (
                                <p className={"warning"}>Vous n'avez pas mis de message</p>
                            )}
                            <Button size={"small"}
                                    btnStyle={"grey"}
                                    onClick={() => setToggle(false)}
                                    content={"Annuler"}/>
                            <Button size={"small"}
                                    btnStyle={"primary-reverse"}
                                    onClick={() => handleSubmit()}
                                    content={"Envoyer"}/>
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    );
}
export default Report;